// extracted by mini-css-extract-plugin
export default {"container":"purchasereward_container__8-+us","img":"purchasereward_img__t3z7g","content":"purchasereward_content__6Tn4i","state":"purchasereward_state__5fsgg"};